module.exports = __webpack_public_path__ + "static/media/dashboardEn.f060698a.svg";